import {Grid, VStack} from 'platform/foundation';
import {useDateTimeFormatter} from 'platform/locale';

import {isNil} from 'ramda';

import {PaymentTypeResponseBody} from '@dms/api/core';
import {CustomerResponseBodyV2} from '@dms/api/customer';
import {BaseAuthorizationProfile} from '@dms/api/security';
import {GetDeliveryNoteResponse, GetWarehousesResponse} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {getCustomerName} from '@dms/shared';
import {ReadOnlyField} from '@dms/shared-aftersales';

import {EMPTY_PLACEHOLDER, Nullish, parseDate, Unpacked} from 'shared/web';

interface BasicInformationReadOnlyProps {
  deliveryNote: GetDeliveryNoteResponse | Nullish;
  supplier: CustomerResponseBodyV2 | Nullish;
  warehouse: Unpacked<GetWarehousesResponse> | Nullish;
  paymentType: Unpacked<PaymentTypeResponseBody[]> | Nullish;
  authorizationProfile: Unpacked<BaseAuthorizationProfile[]> | Nullish;
}

export function BasicInformationReadOnly(props: BasicInformationReadOnlyProps) {
  const dateTimeFormatter = useDateTimeFormatter();

  const formatToShortDate = (date?: string) => {
    if (isNil(date)) {
      return EMPTY_PLACEHOLDER;
    }
    return dateTimeFormatter('dateShort', parseDate(date));
  };

  return (
    <VStack spacing={4}>
      <Grid columns={4}>
        <ReadOnlyField
          label={i18n.t('entity.warehouse.labels.supplier')}
          value={getCustomerName(props.supplier)}
        />
        <ReadOnlyField
          label={i18n.t('entity.warehouse.labels.warehouse')}
          value={props.warehouse?.name}
        />
        <ReadOnlyField
          label={i18n.t('entity.warehouse.labels.authorizationProfile')}
          value={props.authorizationProfile?.name}
        />
        <div />
        <ReadOnlyField
          label={i18n.t('entity.warehouse.labels.deliveryNoteNumber')}
          value={props.deliveryNote?.deliveryNoteNumber}
        />
        <ReadOnlyField
          label={i18n.t('entity.warehouse.labels.deliveryNoteIssueDate')}
          value={formatToShortDate(props.deliveryNote?.issuedAt)}
        />
        <ReadOnlyField
          label={i18n.t('entity.warehouse.labels.invoiceNo')}
          value={props.deliveryNote?.invoiceNumber}
        />
        <ReadOnlyField
          label={i18n.t('entity.warehouse.labels.invoiceIssueDate')}
          value={formatToShortDate(props.deliveryNote?.invoiceIssueDate)}
        />
        <ReadOnlyField
          label={i18n.t('entity.warehouse.labels.paymentType')}
          value={props.paymentType?.value}
        />
        <ReadOnlyField
          label={i18n.t('entity.warehouse.labels.currency')}
          value={props.deliveryNote?.currency}
        />
        <ReadOnlyField
          label={i18n.t('entity.warehouse.labels.exchangeRate')}
          value={props.deliveryNote?.exchangeRate}
        />
        <ReadOnlyField
          label={i18n.t('entity.warehouse.labels.ncConversion')}
          value={props.deliveryNote?.ncConversion}
        />
        <ReadOnlyField
          label={i18n.t('entity.warehouse.labels.note')}
          value={props.deliveryNote?.note}
        />
      </Grid>
    </VStack>
  );
}
